var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayesrWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.99 19.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.25,16.9l1.3.6v-9L.15,14.4c-.4,1,0,2.2,1.1,2.6M20.75,13.2L15.75,1.2c-.3-.8-1-1.2-1.8-1.2-.3,0-.5,0-.8.2l-7.4,3c-.8.3-1.2,1-1.2,1.8,0,.3,0,.5.2.8l5,12c.3.8,1.1,1.2,1.8,1.2.3,0,.5,0,.8-.1l7.4-3c1-.4,1.5-1.6,1.1-2.6M6.65,6.1c-.6,0-1-.4-1-1s.4-1,1-1,1,.4,1,1-.4,1-1,1M4.65,17.1c0,1.1.9,2,2,2h1.4l-3.4-8.3v6.3Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayesrWhite);
export default __webpack_public_path__ + "static/media/layesr_white.830ce485d5d09ce602d5336b800a0454.svg";
export { ForwardRef as ReactComponent };